import { ActionType, createAction, createReducer } from 'typesafe-actions';
import { setSelectedQuantity } from './actions';
import { PDPApiAssemblyServiceProduct, PDPAssemblyService } from './types';

export const addAssemblyService = createAction('@PRODUCT_DETAILS/ASSEMBLY/ADD', action => {
    return () => action();
});

export const removeAssemblyService = createAction('@PRODUCT_DETAILS/ASSEMBLY/REMOVE', action => {
    return () => action();
});

export type AssemblyServiceActionsType =
    | ActionType<typeof addAssemblyService>
    | ActionType<typeof removeAssemblyService>;

export const AssemblyServiceActions = [addAssemblyService, removeAssemblyService];

const formatLabel = (templateLabel: string, quantity: number = 1) => {
    const prefix = quantity > 1 ? `${quantity} x ` : '';

    return templateLabel.replace('%s', `${prefix}`);
};

export const getAssemblyService = (
    assemblyService?: PDPApiAssemblyServiceProduct,
    quantity: number = 1
): PDPAssemblyService => {
    const { text } = assemblyService || {
        text: '',
        price: '',
    };

    return {
        selected: false,
        templateLabel: text,
        label: formatLabel(text, quantity),
    };
};

export const assemblyServiceDefaultState = {
    selected: false,
    templateLabel: '',
    label: '',
};

const assemblyServiceReducer = createReducer<
    PDPAssemblyService,
    AssemblyServiceActionsType | ActionType<typeof setSelectedQuantity>
>(assemblyServiceDefaultState)
    .handleAction(addAssemblyService, state => ({ ...state, selected: true }))
    .handleAction(removeAssemblyService, state => ({ ...state, selected: false }))
    .handleAction(setSelectedQuantity, (state, { payload: { selectedQuantity } }) => ({
        ...state,
        label: formatLabel(state.templateLabel, selectedQuantity),
    }));

export default assemblyServiceReducer;
